import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDiscoverIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.50034 2.5H13.0883L14.7958 4.84778L13.074 7H8.50034V13.5H11.3337V14.5H4.66701V13.5H7.50034V10.3333H2.92669L1.19336 8.16667L2.92669 6H7.50034V2.5ZM8.50034 6H12.5934L13.5382 4.81889L12.5791 3.5H8.50034V6ZM7.50034 7H3.40732L2.47398 8.16667L3.40732 9.33333H7.50034V7Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDiscoverIcon);
export default ForwardRef;
